import * as React from 'react';

function ValueScore({data} :any) {
  return (
    <div className="col-md-4 stretch-card grid-margin">
      <div className={`card card-img-holder text-white ${data.decode_investing_score_color}`}>
        <div className="card-body">
          <h4 className="font-weight-normal mb-3">Overall Value Score <i className="mdi mdi-diamond mdi-24px float-right"></i>
          </h4>
          <h2 className="mb-5">{data.decode_investing_score}%</h2>
          <h6 className="card-text">{data.decode_investing_score_meaning}</h6>
        </div>
      </div>
    </div>
  );
}

export default ValueScore;
